// extracted by mini-css-extract-plugin
export default {"slider_container":"signUp-slider_slider_container__Nvv4H"};